import { Dispatch, SetStateAction } from 'react';
import { UseQueryResult, useQuery } from 'react-query';
import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { tagsListKey } from '../constants';
import { tampleteTagsRoute } from '../api/constants';

type useGetTemplateTagsListsProps = {
  templateId?: string | number;
  enabled?: boolean;
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useGetTemplateTagsList = ({
  templateId,
  enabled,
  setErrorText = () => {},
}: useGetTemplateTagsListsProps) => {
  const queryString = `?${templateId ? `template_id=${templateId}` : ''}`;

  const {
    data: tagsList,
    isFetching: isLoadingTagsList,
  }: UseQueryResult<any, any> = useQuery({
    queryKey: [tagsListKey],
    enabled: enabled,
    queryFn: () =>
      axiosInstance
        .get(tampleteTagsRoute + queryString)
        .then((res) => res.data),
    onSuccess: (data) => {
      setErrorText('');
    },
    onError: () => {
      setErrorText(errorMessage);
    },
    refetchOnWindowFocus: false,
  });

  return {
    tagsList,
    isLoadingTagsList,
  };
};
